/* esm.sh - applesauce-core@5.2.0/operations/tag/relay */
export * from "/*applesauce-core@5.2.0/esnext/operations/tag/relay.mjs";
